import {
  Component,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { MAIN_NAV_ITEMS, NavItem } from '@core/navigation/nav.config';
import { HeaderVariant } from '@layout/models/layout.model';
import { InfogovLogoComponent } from '@shared/components/infogov-logo/infogov-logo.component';
import { HideOnScrollService } from '@shared/services/hide-on-scroll.service';
import { cn } from '@shared/utils/class-names';
import { DesktopNavComponent } from '../desktop-nav/desktop-nav.component';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { MobileNavComponent } from '../mobile-nav/mobile-nav.component';

@Component({
  selector: 'app-site-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslocoPipe,
    LocalizedRouterLinkPipe,
    InfogovLogoComponent,
    DesktopNavComponent,
    LanguageSwitcherComponent,
    MobileNavComponent,
  ],
  templateUrl: './site-header.component.html',
})
export class SiteHeaderComponent implements OnInit {
  readonly variant = input<HeaderVariant>('minimal');

  private readonly hideOnScroll = inject(HideOnScrollService);

  protected readonly navItems: NavItem[] = MAIN_NAV_ITEMS;
  protected readonly cn = cn;
  protected readonly mobileOpen = signal(false);
  protected readonly mobileOpenGroup = signal<string | null>(null);

  protected readonly hidden = this.hideOnScroll.hidden;

  ngOnInit(): void {
    this.hideOnScroll.connect();
  }

  protected get isDark(): boolean {
    return this.variant() === 'dark';
  }

  protected openMobile(): void {
    this.mobileOpen.set(true);
  }

  protected closeMobile(): void {
    this.mobileOpen.set(false);
    this.mobileOpenGroup.set(null);
  }

  protected toggleMobileGroup(labelKey: string): void {
    this.mobileOpenGroup.update((current) => (current === labelKey ? null : labelKey));
  }
}
